module.exports = __webpack_public_path__ + "static/fungi-89704563231540a5560474da9c8ab0bc.svg";